import {OutfitImage} from "./outfit-image";
import {Product} from "../services/product/models";

export class Collection {
  public id: string;
  public displayName: string;
  public mobileBannerKey: string;
  public name: string;
  public outfits: Outfit[];
  public publishFrom: Date;
  public publishTill: Date;
  public state: string;
  public type: string

  constructor(values: any) {
    this.id = values.id;
    this.displayName = values.display_name;
    this.mobileBannerKey = values.mobile_banner_key;
    this.name = values.name;
    this.outfits = values.outfits?.map(o => new Outfit(o));
    this.publishFrom = new Date(values.publish_from);
    this.publishTill = new Date(values.publish_till);
    this.state = values.state;
    this.type = values.type;
  }

  getOutfit(position) {
    for (const outfit of this.outfits) {
      if (outfit.position === position) {
        return outfit;
      }
    }
  }

  getCutouts() {
    const result = new Map<string, string>();
    for (const outfit of this.outfits) {
      if (!outfit.products) {
        continue;
      }
      for (const outfitProduct of outfit.products) {
        for (const variant of outfitProduct.product.variants) {
          result.set(`${variant.productId}-${variant.id}`, variant.getCutout())
        }
      }
    }
    return result;
  }
}

export class CollectionOrder {
  constructor(private outfitImages: OutfitImage[]) {
  }

  getNextOutfit(outfitId: string): any {
    const index = this.outfitImages.findIndex((outfitImage: OutfitImage) => outfitImage.getOutfit()?.id === outfitId)
    const nextOutfitImage = index < (this.outfitImages.length - 1) ? (this.outfitImages[index + 1]) : this.outfitImages[0];
    return nextOutfitImage.getOutfit();
  };

  getPrevOutfit(outfitId: string): any {
    const index = this.outfitImages.findIndex((outfitImage: OutfitImage) => outfitImage.getOutfit()?.id === outfitId)
    const prevOutfitImage = index === 0 ? this.outfitImages[(this.outfitImages.length - 1)] : this.outfitImages[index - 1];
    return prevOutfitImage.getOutfit();
  };
}

export class Outfit {
  public id: string;
  public imageKey: string;
  public imageOrientation: string;
  public name: string;
  public position: number;
  public products: OutfitProduct[];
  public state: string;

  constructor(values: any) {
    this.id = values.id;
    this.name = values.name;
    this.position = values.position;
    this.state = values.state;
    this.imageKey = values.image_key;
    this.imageOrientation = values.image_orientation;
    this.products = values.products?.map(op => new OutfitProduct(op));
  }
}

export class OutfitProduct {
  public product_id: string;
  public variant_id: string;
  public product: Product;

  constructor(values: any) {
    this.product_id = values.product_id;
    this.variant_id = values.variant_id;
    this.product = new Product(values.product);
  }
}

